import React from "react";
import FileUploader from "../../../components/FileUploader/FileUploader";

interface SpouseDocumentsSectionProps {
  userData: any;
  errors: any;
  onInputChange: (e: any, name: string) => void;
  isMarried: boolean;
}

const SpouseDocumentsSection: React.FC<SpouseDocumentsSectionProps> = ({ userData, errors, onInputChange, isMarried }) => {
  return (
    <div className="form-section">
      <div className="section-title mt-3">
        <i className="pi pi-file"></i>
        <h3>Upload Spouse Document</h3>
      </div>

      <div className="">
        {/* SPOUSE DETAILS */}
        {(userData.dec_marrige_status === "Married" || userData?.dec_marrige_status === "Living common-law") &&
          userData.is_spouse_canadian_resident === "1" && (
            <div className="grid p-fluid formgrid form-max-heigth">
              {/* Spouse T4 Upload */}
              <div className="field col-12 md:col-4">
                <label htmlFor="spouse_t4_file">
                  T4 Of All The Jobs You Worked <span className="required"></span>
                </label>
                <FileUploader name="spouse_t4_file" onInputChange={onInputChange} multiple={true} maxSize={10} value={userData.spouse_t4_file} />
                <small className="p-invalid-txt">{errors["spouse_t4_file"]}</small>
              </div>

              {/* Spouse T2202A Upload */}
              <div className="field col-12 md:col-4">
                <label htmlFor="spouse_t2202a_file">
                  Upload T2202A File
                  <span className="required"></span>
                </label>
                <FileUploader
                  name="spouse_t2202a_file"
                  onInputChange={onInputChange}
                  multiple={false}
                  maxSize={10}
                  value={userData.spouse_t2202a_file}
                />
                <small className="p-invalid-txt">{errors["spouse_t2202a_file"]}</small>
              </div>

              {/* Spouse T4a Upload */}
              <div className="field col-12 md:col-4">
                <label htmlFor="spouse_t4a_file">
                  T4A Of All The Jobs You Worked <span className="required"></span>
                </label>
                <FileUploader name="spouse_t4a_file" onInputChange={onInputChange} multiple={true} maxSize={10} value={userData.spouse_t4a_file} />
                <small className="p-invalid-txt">{errors["spouse_t4a_file"]}</small>
              </div>

              {/* Spouse T5007 Upload */}
              <div className="field col-12 md:col-4">
                <label htmlFor="spouse_t5007_file">
                  Upload T5007 File <span className="required"></span>
                </label>
                <FileUploader
                  name="spouse_t5007_file"
                  onInputChange={onInputChange}
                  multiple={false}
                  maxSize={10}
                  value={userData.spouse_t5007_file}
                />
                <small className="p-invalid-txt">{errors["spouse_t5007_file"]}</small>
              </div>

              {/* Spouse T5008 Upload */}
              <div className="field col-12 md:col-4">
                <label htmlFor="spouse_t5008_file">
                  Upload T5008 File
                  <span className="required"></span>
                </label>
                <FileUploader
                  name="spouse_t5008_file"
                  onInputChange={onInputChange}
                  multiple={false}
                  maxSize={10}
                  value={userData.spouse_t5008_file}
                />
                <small className="p-invalid-txt">{errors["spouse_t5008_file"]}</small>
              </div>

              {/* Spouse t5_file Upload */}
              <div className="field col-12 md:col-4">
                <label htmlFor="spouse_t5_file">
                  Upload T5 File <span className="required"></span>
                </label>
                <FileUploader name="spouse_t5_file" onInputChange={onInputChange} multiple={false} maxSize={10} value={userData.spouse_t5_file} />
                <small className="p-invalid-txt">{errors["spouse_t5_file"]}</small>
              </div>

              {/* spouse uber file */}
              <div className="field col-12 md:col-4">
                <label htmlFor="spouse_uber_file">
                  Upload Uber Eats / DoorDash / SkipTheDishes <span className="required"></span>
                </label>
                <FileUploader name="spouse_uber_file" onInputChange={onInputChange} multiple={true} maxSize={10} value={userData.spouse_uber_file} />
                <small className="p-invalid-txt">{errors["spouse_uber_file"]}</small>
              </div>

              {/* Spouse T4 Upload */}
              <div className="field col-12 md:col-4">
                <label htmlFor="spouse_other_file">
                  Upload Other File <span className="required"></span>
                </label>
                <FileUploader
                  name="spouse_other_file"
                  onInputChange={onInputChange}
                  multiple={true}
                  maxSize={10}
                  value={userData.spouse_other_file}
                />
                <small className="p-invalid-txt">{errors["spouse_other_file"]}</small>
              </div>
            </div>
          )}
      </div>
    </div>
  );
};

export default SpouseDocumentsSection;
